import { render, staticRenderFns } from "./offer-feedback-template.vue?vue&type=template&id=d6122444&"
import script from "./offer-feedback-template.vue?vue&type=script&lang=js&"
export * from "./offer-feedback-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports